module.exports = __webpack_public_path__ + "img/ch79.869fa05f.jpg";